// extracted by mini-css-extract-plugin
module.exports = {"container":"PrivacyPolicy_container__2Qvwc","main":"PrivacyPolicy_main__1_Pxi","featured":"PrivacyPolicy_featured__3ZIsf","details":"PrivacyPolicy_details__1nTOO"};